import './modalContent.css'

export default function WellOfKnowledge() {
  return (
    <div className='modal-content'>
      <h2 className='modal-header'>The Well of Knowledge</h2>
      <div className='modal-body'>
        <h3>A Dive into Learning</h3>
        <p>
          Welcome to the Well of Knowledge on Tim's Planet! Just like any well, it's deep with stories and milestones.
          Here, I'd love to share with you the journey of my education - the foundation that supports all the creations
          and adventures you see around.
        </p>
        <h3>🌱 The Early Years: A Missouri Beginning</h3>
        <p>
          My academic adventure began in the small, close-knit community of Gainesville, Missouri. It was here, amidst
          the rolling hills and friendly faces, that I attended kindergarten through 3rd grade. These early years were
          filled with the fundamental building blocks of education and set the stage for my lifelong love of learning.
        </p>
        <h3>🏠 Homeschooling: A Personalized Path</h3>
        <p>
          From the 4th grade onward, my classroom was my home. Homeschooling allowed me to learn at my own pace, explore
          subjects that interested me deeply, and develop self-discipline and independent study skills. This unique
          experience culminated in me obtaining my GED at the age of 17, marking an early milestone in my academic
          journey.
        </p>
        <h3>🎓 Ozarks Technical Community College: Stepping into Higher Education</h3>
        <p>
          After taking a few years to explore my interests and the world around me, I enrolled at Ozarks Technical
          Community College (OTC). During my time at OTC, I pursued an Associate of the Arts degree, a period marked by
          dedication and academic success. I found myself on the Dean's List for multiple semesters and graduated with a
          4.0 GPA - a testament to my commitment and hard work.
        </p>
        <h3>🏢 Missouri State University: Continuing To Grow</h3>
        <p>
          The journey didn't stop there. I transitioned seamlessly to Missouri State University, where I dove into the
          world of Computer Information Systems (CIS). These years were filled with intensive learning, practical
          application, and a growing passion for technology and its potential. In 2018, I graduated with 4.0 GPA and a
          Bachelor of Science in Computer Information Systems. My time at Missouri State was not just about grades - it
          was also about making a mark. I was honored with the "Outstanding CIS Student" award for the 2017-2018
          academic year, a recognition that meant the world to me.
        </p>
        <h3>🌟 A Journey of Growth and Learning</h3>
        <p>
          The Well of Knowledge here on Tim's Planet is a reflection of my educational path - a path characterized by
          curiosity, dedication, and the pursuit of excellence. From the small classrooms of Gainesville to the halls of
          Missouri State University, every step has contributed to who I am today - not just as a professional, but as a
          lifelong learner and explorer.
        </p>
        <p>
          Thank you for visiting the Well of Knowledge. I hope my journey inspires you as you explore your own paths in
          learning and life!
        </p>
      </div>
    </div>
  )
}
